import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { shipmentContext } from '../ShipmentContext';
import { CircleLoader, DetailsPageHeader } from 'components';

let ShipmentLines = () => {
    let service = useContext(shipmentContext);

    return (
        <DetailsPageHeader sectionName='Info'>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>SKU</TableCell>
                            <TableCell>Order</TableCell>
                            <TableCell align="center">Quantity</TableCell>
                            <TableCell align="center">ERP Order Line Id</TableCell>
                            <TableCell align="center">ERP Order Number</TableCell>
                            <TableCell>Invoiced</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.shipment.shipmentLines
                            .map((shipmentLine, index) =>
                                <TableRow hover key={index}>
                                    <TableCell>{shipmentLine.sku}</TableCell>
                                    <TableCell>
                                        <Link component={RouterLink} to={`/order/${shipmentLine.orderId}`}>
                                            {shipmentLine.orderNumber}
                                        </Link>
                                    </TableCell>
                                    <TableCell align="center">{shipmentLine.quantity}</TableCell>
                                    <TableCell align="center">{shipmentLine.eRPOrderLineId}</TableCell>
                                    <TableCell align="center">{shipmentLine.eRPOrderNumber}</TableCell>
                                    <TableCell>{shipmentLine.isInvoiced === true ? 'Yes' : 'No'}</TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                    {(!service.shipment.shipmentLines || service.shipment.shipmentLines.length === 0) &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <Typography variant="subtitle2">No shipment lines found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
        </DetailsPageHeader>
    );
}

export default ShipmentLines;